import { useCallback, useState } from 'react';
import { AlertType, ShowAlertFunction } from '../types';

export const useAlertState = () => {
  const [alert, setAlertState] = useState<AlertType | undefined>(undefined); // eslint-disable-line no-undefined
  const showAlert: ShowAlertFunction = useCallback((alertType, content) => setAlertState({
    show: true,
    alertType,
    content,
  }), [setAlertState]);

  const hideAlert = useCallback(() => setAlertState(undefined), [setAlertState]); // eslint-disable-line no-undefined

  return {
    alert,
    showAlert,
    hideAlert,
  };
};
